// Vendors
import { apiUtils } from '@openbank/cf-ui-architecture-core';
// Constants
import { GET_ONB_STATE_SERVICE_CONFIGURATION } from './constants/get-state.service.constants';
// Types
import { GetStateApiResponseType } from 'types/get-state-api-response.type';

const getCurrentOnboardingStateService = async (): Promise<[GetStateApiResponseType, Response]> =>
  apiUtils.get(GET_ONB_STATE_SERVICE_CONFIGURATION);

export { getCurrentOnboardingStateService };
